<template>
  <div class="alert-table">
    <!-- Table for alerts -->
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Interval</th>
          <th>Devicetype</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody v-if="ajaxCompleted">
        <tr
          v-for="alert in alerts"
          @click="handleRowClick(alert._id)"
          :data-id="alert._id"
          :key="alert._id"
        >
          <td>
            {{ alert.name }}
          </td>
          <td>
            {{ duration(alert.interval * 1000) }}
          </td>
          <td>
            {{ alert.devicetype }}
          </td>
          <td>
            <span v-if="alert.available"><i class="uil uil-check" /></span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="5" class="loader">
            <img :src="loadingImage" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Utils from '@/utils';

export default {
  name: 'AlertTable',
  props: ['savedAt'],
  data() {
    return {
      ajaxCompleted: false,
      alerts: [],
    };
  },
  watch: {
    savedAt() {
      this.getalerts();
    },
  },
  methods: {
    async getalerts() {
      const response = await Utils.fetch('/api/v1/alerts', {}, this).then((res) => res.json());
      if (response.success) {
        this.ajaxCompleted = true;
        this.alerts = response.alerts;
      }
    },
    async handleRowClick(id) {
      this.$emit('rowClick', id);
      this.$router.replace(`/alerts/manager/${id}`);
    },
    duration(ms) {
      return Utils.duration(ms);
    },
  },
  mounted() {
    this.getalerts();

    this.$root.$on('reloadTable', () => {
      this.getalerts();
    });
  },
};
</script>

<style lang="scss" scoped>
.alert-table {
  overflow-x: auto;
  padding-bottom: 30px;
}

.alert-table table {
  width: 100%;
  border-collapse: collapse;

  .loader {
    text-align: center;
    padding: 20px 0;

    img {
      height: 30px;
    }
  }

  tr {
    height: 30px;
  }

  tbody tr {
    cursor: pointer;

    &.selected {
      background: var(--table-row-hover-color);
    }

    &:hover {
      background: var(--table-row-hover-color);
    }
  }

  th,
  td {
    padding: 0 10px;
  }

  thead tr th {
    text-align: left;
    background: var(--table-header-color);
  }

  th {
    font-weight: normal;
  }
}

.bullet {
  height: 10px;
  width: 10px;
  display: inline-block;
  border-radius: 100%;

  &.blue {
    background: rgb(88, 195, 220);
  }

  &.green {
    background: #4dbd74;
  }

  &.red {
    background: #f86c6b;
  }
}
</style>
